module.exports = __webpack_public_path__ + "img/xufei.c26a044.png";